import {
  LOGIN_INPUT_USERNAME,
  LOGIN_INPUT_PASSWORD
} from '../constants/login'

export const getStatus = state => state.login.status
export const getFocusedInput = state => state.login.focusedInput
export const getUsername = state => state.login[LOGIN_INPUT_USERNAME]
export const getPassword = state => state.login[LOGIN_INPUT_PASSWORD]
export const getUsernameError = state => state.login.errors[LOGIN_INPUT_USERNAME]
export const getPasswordError = state => state.login.errors[LOGIN_INPUT_PASSWORD]
export const getKeyboardFocused = state => state.login.keyboardFocused
export const getFocusedRow = state => state.login.focusedRow
export const getFocusedCol = state => state.login.focusedCol
